// extracted by mini-css-extract-plugin
export default {"root":"root--Ad6t3","hidden":"hidden--hlVEc","squared":"squared--_Vprf","default":"default--BtqWl"};